import { createSelector } from 'reselect'

/**
 * Select the UI state slice
 * @param {object} state - Redux state
 * @returns {object} UI state
 */
export const selectUi = (state) => state.ui

/**
 * Select the loading indicators array
 * @param {object} state - Redux state
 * @returns {Array} Loading indicators
 */
export const selectIsLoading = createSelector(
  selectUi,
  (ui) => ui.isLoading
)

/**
 * Select whether the tab bar is hidden
 * @param {object} state - Redux state
 * @returns {boolean} Tab bar hidden status
 */
export const selectHideTabBar = createSelector(
  selectUi,
  (ui) => ui.hideTabBar
)

/**
 * Select the confirmation modal state
 * @param {object} state - Redux state
 * @returns {object|null} Confirmation modal data
 */
export const selectConfirmationModal = createSelector(
  selectUi,
  (ui) => ui.confirmationModal
)

/**
 * Create a memoized selector for a specific loading type
 * @param {string} loadingType - The loading type to check
 * @returns {Function} Selector that returns whether the loading type is active
 */
export const makeSelectIsLoadingType = (loadingType) =>
  createSelector(
    selectIsLoading,
    (isLoading) => isLoading.some((item) => item.loadingType === loadingType)
  )
